class sideMenu {
    constructor (theme, elem) {
        this._theme = theme
        this._container = elem.querySelector('[data-side-menu-container]')
        this._sideMenu = elem.querySelector('[data-side-menu]')
        this._sideMenuToggles = elem.querySelectorAll('[data-side-menu-toggle]')
        this._listMasters = elem.querySelectorAll('[data-toggle-list-master]')
        this._listSlaves = elem.querySelectorAll('[data-toggle-list-slave]')
        this._elemReverse = elem.querySelectorAll('[data-side-menu-toggle-reverse]')
        this.initialised = false
        this.currOpen = null
        this.openedSlave = null
        this._evt = new CustomEvent('side-menu-toggled')
    }

    onInit () {
        this._sideMenu.sideMenuRef = this
        this.innerMenus()
        this.setPosition(this._sideMenu)
        this.setToggles(this._sideMenuToggles)
        for (let elem of this._listSlaves) {
            this.setPosition(elem)
        }
        this.initialised = true
        document.body.addEventListener('overlay-hit', e => {
            if (this.currOpen) {
                this.setPosition(this.currOpen, true)
                this.currOpen = null
            }
        })
    }

    setToggles (toggles) {
        for (let toggle of this._sideMenuToggles) {
            toggle.addEventListener('click', e => {
                this.setPosition(this._sideMenu, true)
                let productModal = document.body.querySelector('[data-product-modal-container]')
                let instaModal = document.body.querySelector('#shoppableModal')
                if (productModal) {
                    if (productModal.modalRef && productModal.modalRef.open) {
                        productModal.modalRef.turnOff(true)
                    }
                }
                if (instaModal) {
                    if (instaModal.open) {
                        instaModal.ref.turnModalOff(true)
                    }
                }
            })
        }
    }

    setPosition (sideMenu, master) {
        if (!this.initialised) {
            sideMenu.style.left = -sideMenu.offsetWidth + 'px'
            sideMenu.open = false
            return false
        }
        if (this.currOpen) {
            this.currOpen.style.left = -this.currOpen.offsetWidth + 'px'
            if (master) {
                this.currOpen = null
                this.fireEvt(false)
                return false
            }
        }
        if (!this.currOpen) {
            this.fireEvt(true)
        }
        sideMenu.style.left = sideMenu.open ? -sideMenu.offsetWidth + 'px' : '0px'
        this.currOpen = sideMenu
    }

    fireEvt (status) {
        this.open = status
        this._evt.open = status
        this._sideMenu.dispatchEvent(this._evt)
    }

    innerMenus () {
        for (let [index, elem] of this._listMasters.entries()) {
            elem.addEventListener('click', e => {
                this.openedSlave = this._listSlaves[index]
                this.openedSlave.classList.add('open')
                this.setPosition(this.openedSlave)
            })
        }
        for (let elem of this._elemReverse) {
            elem.addEventListener('click', e => {
                this.openedSlave.classList.remove('open')
                this.setPosition(this._sideMenu)
            })
        }
    }
}

export default sideMenu



// WEBPACK FOOTER //
// ./src/scripts/components/header/SideMenu.js